// extracted by mini-css-extract-plugin
export default {"containerModal":"ModalOfUnit_containerModal__vCf9R","section":"ModalOfUnit_section__TJ7GV","rowButton":"ModalOfUnit_rowButton__TcncC","button":"ModalOfUnit_button__xd8Kg"};